export default __webpack_public_path__ + "static/media/ic_close.7ce3b5e8.svg";